import React, { useState } from 'react';
import { AppContext } from './context/AppContext';
import UploadMaterials from './components/UploadMaterials';
import ReviewSummary from './components/ReviewSummary';
import ThemeBlocks from './components/ThemeBlocks';
import './styles/App.css';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const STEPS = [
  { num: 1, label: 'Material' },
  { num: 2, label: 'Temas' },
  { num: 3, label: 'Apostilas' }
];

function App() {
  const [step, setStep] = useState(1);
  const [appState, setAppState] = useState({
    resumo: null,
    topicos: [],
    grupos: [],
    loading: false,
    error: null
  });

  const updateState = (newState) =>
    setAppState(prev => ({ ...prev, ...newState }));

  const handleReset = () => {
    setStep(1);
    setAppState({ resumo: null, topicos: [], grupos: [], loading: false, error: null });
  };

  // Chamado quando o usuário confirma os tópicos no ReviewSummary
  const handleTopicsConfirmed = async () => {
    updateState({ loading: true, error: null });
    try {
      const res = await fetch(`${API}/materials/group`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ topicos: appState.topicos })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erro ao agrupar temas');
      updateState({ grupos: data.grupos, loading: false });
      setStep(3);
    } catch (e) {
      updateState({ error: e.message, loading: false });
    }
  };

  return (
    <AppContext.Provider value={{ appState, updateState }}>
      <div className="app">
        <header className="app-header">
          <div className="header-content">
            <h1>🎓 Nutrir Atualizador de Materiais</h1>
            <p>Atualize seus materiais de aula com conteúdo científico recente em poucos cliques</p>
          </div>
        </header>

        <main className="app-main">

          {/* Barra de progresso */}
          <div className="progress-bar">
            {STEPS.map(({ num, label }) => (
              <div key={num} className={`progress-step-item ${step > num ? 'done' : step === num ? 'active' : ''}`}>
                <div className="step-circle">{step > num ? '✓' : num}</div>
                <span className="step-label">{label}</span>
              </div>
            ))}
          </div>

          {/* Passo 1: Upload */}
          {step === 1 && (
            <section className="step-section">
              <h2>Passo 1: Carregue seu Material</h2>
              <UploadMaterials
                onNext={() => setStep(2)}
                onError={(err) => updateState({ error: err })}
              />
            </section>
          )}

          {/* Passo 2: Revisão dos tópicos + agrupamento */}
          {step === 2 && (
            <section className="step-section">
              <h2>Passo 2: Confirme os Temas Identificados</h2>
              {appState.loading ? (
                <div className="step-content">
                  <div style={{ textAlign: 'center', padding: 48 }}>
                    <div className="spinner" style={{ margin: '0 auto 18px' }}></div>
                    <p style={{ color: '#385e81', fontWeight: 600 }}>Organizando tópicos por tema clínico...</p>
                    <p style={{ color: '#888', fontSize: 13 }}>A IA está agrupando os assuntos dos seus materiais.</p>
                  </div>
                </div>
              ) : (
                <ReviewSummary
                  onApprove={handleTopicsConfirmed}
                  onReject={() => setStep(1)}
                />
              )}
            </section>
          )}

          {/* Passo 3: Blocos por tema — busca + criação de apostilas */}
          {step === 3 && (
            <section className="step-section">
              <h2>Passo 3: Buscar Atualizações e Criar Apostilas</h2>
              <ThemeBlocks onReset={handleReset} onBack={() => setStep(2)} />
            </section>
          )}

          {/* Banner de erro global */}
          {appState.error && (
            <div className="error-banner">
              <p>❌ {appState.error}</p>
              <button onClick={() => updateState({ error: null })}>Fechar</button>
            </div>
          )}
        </main>

        <footer className="app-footer">
          <p>© 2026 Instituto Nutrir | Todos os direitos reservados</p>
        </footer>
      </div>
    </AppContext.Provider>
  );
}

export default App;
